import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import { Pagination, Autoplay } from 'swiper/modules';

const Hometestinomials = () => {
  return (
    <section id="testimonials" className="testimonials section light-background">
      <div className="container section-title">
        <h2>Testimonials</h2>
        <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
      </div>
      <div className="container">
        <Swiper
          loop={true}
          speed={600}
          autoplay={{ delay: 5000 }}
          slidesPerView="auto"
          pagination={{ clickable: true }}
          modules={[Pagination, Autoplay]}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 40,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 1,
            },
          }}
        >
          <SwiperSlide>
            <div className="testimonial-item">
              <div className="profile mt-auto">
                <img
                  src="https://sigohrmlpadmin.loopring.in/front/images/testonomials/81451.jpg"
                  className="testimonial-img"
                  alt=""
                />
                <h3>Saul Goodman</h3>
                <h4>Ceo & Founder</h4>
              </div>
              <p className="mt-2">
                Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit
                rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam,
                risus at semper.
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="testimonial-item">
              <div className="profile mt-auto">
                <img
                  src="https://sigohrmlpadmin.loopring.in/front/images/testonomials/81451.jpg"
                  className="testimonial-img"
                  alt=""
                />
                <h3>Saul Goodman</h3>
                <h4>Ceo & Founder</h4>
              </div>
              <p className="mt-2">
                Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit
                rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam,
                risus at semper.
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="testimonial-item">
              <div className="profile mt-auto">
                <img
                  src="https://sigohrmlpadmin.loopring.in/front/images/testonomials/81451.jpg"
                  className="testimonial-img"
                  alt=""
                />
                <h3>Saul Goodman</h3>
                <h4>Ceo & Founder</h4>
              </div>
              <p className="mt-2">
                Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit
                rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam,
                risus at semper.
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="testimonial-item">
              <div className="profile mt-auto">
                <img
                  src="https://sigohrmlpadmin.loopring.in/front/images/testonomials/81451.jpg"
                  className="testimonial-img"
                  alt=""
                />
                <h3>Saul Goodman</h3>
                <h4>Ceo & Founder</h4>
              </div>
              <p className="mt-2">
                Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit
                rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam,
                risus at semper.
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="testimonial-item">
              <div className="profile mt-auto">
                <img
                  src="https://sigohrmlpadmin.loopring.in/front/images/testonomials/81451.jpg"
                  className="testimonial-img"
                  alt=""
                />
                <h3>Saul Goodman</h3>
                <h4>Ceo & Founder</h4>
              </div>
              <p className="mt-2">
                Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit
                rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam,
                risus at semper.
              </p>
            </div>
          </SwiperSlide>
         
        </Swiper>
      </div>
    </section>
  );
};

export default Hometestinomials;
